// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Attempt to load user from localStorage at app start
const userFromStorage = localStorage.getItem('user');

const initialState = {
  // If we have a 'user' in localStorage, parse it into Redux
  user: userFromStorage ? JSON.parse(userFromStorage) : null,
  // If userFromStorage exists, then we consider isAuthenticated = true
  isAuthenticated: !!userFromStorage,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    logout: (state) => {
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      // Optionally, also clear localStorage:
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout } = authSlice.actions;
export default authSlice.reducer;
